import Vue from 'vue';

export default {
    name: 'dynamic-master-layout',
    props: {
        name: {
            type: String,
            default: 'MasterLayout',
        },
    },
    created() {
        if (!Vue.options.components[this.name]) {
            Vue.component(
                this.name,
                () => import(`@/layouts/${this.name}.vue`),
            );
        }
        this.$parent.$emit('update:layout', this.name);
    },
    render() {
        return this.$slots.default[0];
    },
}
